// Mumbai 

const tokensMumbai = [
	{
		Network: "Mumbai",
		chainId: 1,
		address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
		testAddress:"0x86C763af11F49188ebDAe8baa03580b076e66656",
		name: "USD Coin",
		symbol: "USDC",
		decimals: 18,
		// decimals: 6,
		scanner: "etherscan",
		logoURI:
			"https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389",
	},
	{
		Network: "Mumbai",
		address: "0x0000000000085d4780b73119b644ae5ecd22b376",
		testAddress:"0x9Ae5cb0069509E42332Fa6768B805Caf4EFab3E3",
		name: "TrueUSD",
		symbol: "TUSD",
		decimals: 18,
		scanner: "etherscan",
		logoURI:
			"https://assets.coingecko.com/coins/images/3449/thumb/tusd.png?1618395665",
	},
	{
		Network: "Mumbai",
		address: "0x6b175474e89094c44da98b954eedeac495271d0f",
		testAddress:"0x72c63c1A41bBc332a6A421674fDA379Da81653cc",
		symbol: "DAI",
		decimals: 18,
		scanner: "etherscan",
		logoURI:
			"https://assets.coingecko.com/coins/images/10843/thumb/aDAI.png?1584698791",
	},
	{
		Network: "Mumbai",
		address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
		testAddress:"0xCCD2737369B6C2568a58dD1FE67989979B24B3F9",
		name: "Tether",
		symbol: "USDT",
		decimals: 6,
		scanner: "bscscan",
		logoURI:
			"https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707",
	},
	{ 
		Network: "Mumbai",
		address: "0x4fabb145d64652a948d72533023f6e7a623c7c53",
		testAddress:"0xAD469E3121503088cfbd0D3c91371883DaEe21E4", // BUSD on Mumbai Matic network Polygon Network
		name: "Binance USD",
		symbol: "BUSD",
		decimals: 18,
		scanner: "bscscan",
		logoURI:
			"https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766",
    },
];
export default tokensMumbai;
